import { jsxs as c, jsx as r } from "react/jsx-runtime";
const n = (o) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ r(
        "path",
        {
          fill: "currentColor",
          d: "M31.99 0C17.663 0 6.048 11.615 6.048 25.942S17.663 51.884 31.99 51.884 57.932 40.27 57.932 25.942 46.319 0 31.99 0Zm15.515 41.457a21.875 21.875 0 0 1-15.515 6.427 21.875 21.875 0 0 1-15.515-6.427 21.873 21.873 0 0 1-6.427-15.515 21.875 21.875 0 0 1 6.427-15.515A21.874 21.874 0 0 1 31.99 4a21.87 21.87 0 0 1 15.516 6.427 21.874 21.874 0 0 1 6.426 15.515 21.873 21.873 0 0 1-6.427 15.515Z"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          fill: "currentColor",
          d: "M32.05 12.96c-6.582 0-12.053 4.854-13.019 11.17h-2.798v4h2.798c.966 6.317 6.437 11.172 13.02 11.172 6.582 0 12.053-4.855 13.019-11.171h2.798v-4H45.07c-.966-6.317-6.437-11.171-13.02-11.171Zm0 22.342c-4.37 0-8.035-3.073-8.95-7.171H41c-.915 4.098-4.58 7.17-8.95 7.17ZM23.1 24.13c.915-4.099 4.58-7.172 8.95-7.172 4.37 0 8.036 3.073 8.951 7.172H23.1Z"
        }
      )
    ]
  }
);
export {
  n as Underground
};
